import { useAuth } from "@/lib/AuthContext";
import { Navigate } from "react-router-dom";

export default function ConnexionPage() {
  const { user, login } = useAuth();
  if (user) return <Navigate to="/mon-compte" replace />;

  return (
    <main className="max-w-md mx-auto px-6 py-16" data-testid="connexion-page">
      <div className="glass-card p-8">
        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-orange-500 to-orange-400 text-white grid place-items-center font-bold text-2xl mx-auto">F</div>
        <h1 className="font-display text-2xl font-extrabold text-center mt-4">Connexion a Fodindin</h1>
        <p className="text-center text-sm text-[var(--ink-soft)] mt-1">Accedez a vos annonces, messages et favoris.</p>

        <button onClick={login} className="btn-primary w-full mt-6 inline-flex items-center justify-center gap-2 !py-3" data-testid="login-open-modal-btn">
          Connexion / Inscription
        </button>

        <p className="text-center text-xs text-[var(--ink-soft)] mt-3">
          Numero de telephone (recommande), email/mot de passe ou Google.
        </p>

        <div className="mt-5 text-xs text-center text-[var(--ink-soft)]">
          En vous connectant, vous acceptez nos <a href="/cgu" className="text-orange-600 font-semibold">CGU</a>.
        </div>
      </div>
    </main>
  );
}
